@if (isVisible()) {
	<div class="global-search-overlay" (click)="onOverlayClick($event)">
		<div class="global-search-container" (keydown)="onOptionShortcut($event)">
			<div class="global-search-header">
				<input
					#input
					type="text"
					class="search-input"
					placeholder="Search in all business objects..."
					[value]="query()"
					(input)="onInput($event)"
					(keydown)="onInputKeyDown($event)"
				/>
				<select
					class="bo-type-select"
					title="Business object type to search"
					(change)="onBoTypeChange($event)"
				>
					<option value="" [selected]="!boType()">(all)</option>
					@for (type of boTypes; track type) {
						<option [value]="type" [selected]="boType() === type">
							{{ type }}
						</option>
					}
				</select>
				<button
					type="button"
					class="toggle"
					[title]="'Match case (' + optionShortcutLabels.isCaseSensitive + ')'"
					[class.active]="isCaseSensitive()"
					[attr.aria-pressed]="isCaseSensitive()"
					(click)="isCaseSensitive.set(!isCaseSensitive())"
				>
					Aa
				</button>
				<button
					type="button"
					class="toggle"
					[title]="
						'Use regular expression (' + optionShortcutLabels.isRegex + ')'
					"
					[class.active]="isRegex()"
					[attr.aria-pressed]="isRegex()"
					(click)="isRegex.set(!isRegex())"
				>
					.*
				</button>
				<button
					type="button"
					class="toggle"
					[title]="
						'Match whole word (' + optionShortcutLabels.isWholeWord + ')'
					"
					[class.active]="isWholeWord()"
					[attr.aria-pressed]="isWholeWord()"
					(click)="isWholeWord.set(!isWholeWord())"
				>
					ab
				</button>
				<button
					type="button"
					class="toggle"
					[title]="
						currentModuleId()
							? 'Only search in module ' + currentModuleId()
							: 'Only search in current module (no module open)'
					"
					[disabled]="!currentModuleId()"
					[class.active]="isCurrentModuleOnly() && currentModuleId()"
					[attr.aria-pressed]="isCurrentModuleOnly() && !!currentModuleId()"
					(click)="isCurrentModuleOnly.set(!isCurrentModuleOnly())"
				>
					<mat-icon>folder</mat-icon>
				</button>
			</div>
			<div class="global-search-content">
				@if (state().isTruncated) {
					<div class="info warning">
						<mat-icon>warning</mat-icon>
						Only the first {{ state().matchCount }} matches are shown. Narrow
						your search to see all results.
					</div>
				}
				@if (state().error) {
					<div class="info error">{{ state().error }}</div>
				} @else if (state().isLoading) {
					<div class="info">Searching...</div>
				} @else if (query() && !state().groups.length) {
					<div class="info">No results</div>
				} @else if (state().groups.length) {
					<div class="info summary">
						{{ state().matchCount }}
						{{ state().matchCount === 1 ? 'match' : 'matches' }} in
						{{ state().groups.length }}
						{{
							state().groups.length === 1
								? 'business object'
								: 'business objects'
						}}
					</div>
				}
				@for (group of state().groups; track group.key) {
					@let isCollapsed = collapsedGroupKeys().has(group.key);
					<div
						class="group"
						[attr.aria-expanded]="!isCollapsed"
						(click)="toggleGroup(group)"
					>
						<mat-icon>{{
							isCollapsed ? 'chevron_right' : 'expand_more'
						}}</mat-icon>
						<span class="bo">
							{{ group.label }}
							<span class="bo-type">{{ group.boType }}</span>
						</span>
						<span class="count">{{ group.results.length }}</span>
					</div>
					@if (!isCollapsed) {
						@for (result of group.results; track $index) {
							<div
								class="result"
								[class.active]="isActive(result)"
								(click)="open(result)"
								(mouseenter)="activate(result)"
							>
								<span class="snippet"
									>{{ result.snippetBefore
									}}<mark>{{ result.matchedText }}</mark
									>{{ result.snippetAfter }}</span
								>
								<span class="breadcrumb">{{ result.breadcrumb }}</span>
							</div>
						}
					}
				}
			</div>
		</div>
	</div>
}
